// extracted by mini-css-extract-plugin
module.exports = {"row":"DecisionTree_row__24Ss2","divLabel":"DecisionTree_divLabel__c3Ey0"};